import {appUrl} from '@frontend/AppUrl'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'

// Создание ссылки на детали обращения в службу поддержки.
export function makeSupportTicketUrl(ticketNumber: number, ticketUuid: string): string {
    return NavigationService.makeUrl(
        appUrl().cabinet.supportTickets.details,
        {
            id: ticketNumber,
            uuid: ticketUuid,
        }
    )
}
